import Vue from 'vue';
import Vuex from 'vuex';

import * as getters from './getters/index';
import * as mutations from './mutations/index';
import * as actions from './actions/index';

Vue.use(Vuex);

let sysParams = window.Config.sysParams;

const state = {
    // 系统参数
    sysParams: {
        securityUrlparamEncodeEnable: sysParams.securityUrlparamEncodeEnable, // 开启参数加密
        securityUrlparamEncodeSkipurl: sysParams.securityUrlparamEncodeSkipurl,
        fileSizeLimit: sysParams.fileSizeLimit, // 传控件限制最大上传附件大小
        fileLimitType: sysParams.fileLimitType, // 上传控件限制上传类型,
        fileNameLengthLimit: sysParams.fileNameLengthLimit, // 限制上传文件名长度
        tablepagesize: sysParams.tablepagesize // 表格列表一页显示多少条
    },

    // 登录状态
    isLogin: false,

    // 用户信息
    userInfo: {
        roles: [], // 用户角色
        userguid: '',
        name: '',
        avatar: '',
        account: '',
        isVip: 0, // 是否vip
        vips: [], // 已开通会员
        isMaster: 0, // 是否达人
        collection: '', // 我的收藏
        resources: '', // 我的收藏

        todayEarnings: '', // 今日收益
        cumulativeIncome: '', // 累计收益
        accountBalance: 0, // 账户余额
        materialNum: 0 // 素材数量
    },

    // 用户路由
    routes: [],

    // 动态添加的路由
    addRouters: [],
    // 开通会员弹窗
    membershipDialog: {
        show: false,
        materialguid: '',
        promocode: '',
        issetdefault: false
    },
    // 素材详情弹窗
    materialDetailDialog: {
        show: false,
        materialguid: ''
    },
    // 页面打开模式 D05为工作台 DesktopApp为浏览器
    platform: ''
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});
